import './MGMessageBox.css'

import React, { useState } from "react";
import "./MGMessageBox.css";

export default function MGMessageBox({
    maxLength = 500,
    value = "",
    placeholder = "Escreva aqui a sua mensagem",
    onChange,
    isEmpty
}) {
    const [message, setMessage] = useState(value);

    const handleChange = (event) => {
        const newValue = event.target.value;

        if (onChange && newValue.trim().length !== 0) {
            onChange(newValue);
            isEmpty(newValue.isEmpty === "");
        }

        if(newValue.length === 0){
            isEmpty(true);
        }
        
        setMessage(newValue);

    };

    return (
        <div className="MGMessageBox">

            <textarea
                name="postContent"
                value={message}
                onChange={handleChange}
                maxLength={maxLength}
                placeholder={placeholder}
            />

            <span className="MGMessageBox-counter">
                {message.length}/{maxLength}
            </span>

        </div>
    );
}